export default {
  name: 'Lead from automatic',
  path: '/lead/:leadId/uid/:uid',
  component: () => import('./lead-from-automatic.vue')
};
